import {round} from './round';

const roundTo1DecimalPlace = (num: number): number => round(1)(num);

export {roundTo1DecimalPlace};
